<template>
    <v-container class="d-flex-column justify-center">
        <v-card :loading="loading" class="mt-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Ισολογισμός</h1>
            <v-spacer></v-spacer>
            <v-chip label>
              {{
              $tocurr(debitTotal)
              }}
            </v-chip>
            <v-chip label>
              {{
              $tocurr(paymTotal)
              }}
            </v-chip>
            <v-container fluid class="mt-2">
          <v-row>
            <v-col cols="12" md="2" >
              <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu = false"
                min="2021-11-01"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="2" >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                :events="functionEvents"
                min="2021-11-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            </v-row>
             <v-divider></v-divider>
            <v-sheet class="mt-4">
            </v-sheet>
            </v-container>
          </v-card-title>
          </v-card>

      <v-card
    class="mt-4 mx-auto"
    max-width="100%"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
   <apexchart
      ref="barChart"
      type="bar"
      height="500"
      :options="chartOptions"
      :series="series"></apexchart>
    </v-sheet>
     <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Ισολογισμός
      </div>
      <div class="subheading font-weight-light grey--text">
        Εισπράξεις/Έξοδα ανά εβδομάδα για το τρέχων έτος.
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-delta
      </v-icon>
      <span class="text-caption grey--text font-weight-light">Μέση τιμή {{weeklyDAvg}}/{{weeklyEAvg}}</span>
    </v-card-text>
  </v-card>
          
    </v-container>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'

export default {

  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    weeklyEAvg () {
        var sum = 0;
        for (var el in this.weeklyE) sum += this.weeklyE[el];
        return this.$tocurr(sum / Object.keys(this.weeklyE).length)
    },
    weeklyDAvg () {
        var sum = 0;
        for (var el in this.weeklyD) sum += this.weeklyD[el];
        return this.$tocurr(sum / Object.keys(this.weeklyD).length)
    },
  },
  watch: {
    async date() {
      if (this.date != this.$route.query.startdate){
      this.$router.replace({
        name: "Isologismos",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchData();
      }
    },
    async date2() {
      if (this.date2 != this.$route.query.enddate){
      this.$router.replace({
        name: "Isologismos",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchData();
      }
    },
  },
  data() {
    return {
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      dialog: false,
      loading: true,
      debitTotal: 0.0,
      paymTotal: 0.0,
      debits: [],
      tabs: [],
      nonBill: [],
      weeklyD: null,
      weeklyE: null,
      breakdown: {cash: 0, card: 0, check: 0, bank: 0},
      menu: false,
      menu2: false,
      search: "",
      
      series: [{
            name: 'Έξοδα',
            data: []
          },
          {
            name: 'Έσοδα',
            data: []
          }],
      
      chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
              toolbar: {
                show: true
              },
              
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
           xaxis: {
              type: "datetime",
              categories: [],
              position: 'top',
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                  }
                }
              },
              tooltip: {
                enabled: true,
              }
            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: true,
              },
              labels: {
                show: true,
                formatter: this.$tocurr,
              },
              title: {
                text: 'Έσοδα/Έξοδα ανά εβδομάδα'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: this.$tocurr
              }
            }
          },
     
      
    };
  },
  async created() {
    if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    await this.fetchData();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    async fetchData() {
    this.loading = true;
       try {
        let response = await this.$api.get("/customers/debits/", {
          params: {
            start_date: this.date,
            end_date: this.date2,
            breakdown: false,
            weekly: 2022,
          },
        });
        // console.log(response.data);

        this.debitTotal = response.data.DebTotal + response.data.TabTotal;
        this.weeklyD = response.data.ByWeek;
        //this.updateChart();
        
        
        let resp = await this.$api.get("/suppliers/debits/", {
          params: {
            start_date: this.date,
            end_date: this.date2,
            breakdown: false,
            weekly: 2022,
          },
        });
        // console.log(response.data);

        this.paymTotal = resp.data.DebTotal + resp.data.TabTotal;
        this.weeklyE = resp.data.ByWeek;
        
        this.updateChart();
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    functionEvents (date) {
      return this.debits.some(e => e.Date == date);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    updateChart () {
      let labels = [];
      //let values =[{data: [], name: "Debit"}];
      //let values =[{ data: [], name: "Income"}, {data: [], name: "Expenses"}];
      for (let date in this.weeklyD ) {
        //if (this.date <= date && this.date2 >= date) {
        labels.push(date);
        this.series[1].data.push({
         x: date,
         y: this.weeklyD[date],
         });
         this.series[0].data.push({
         x: date,
         y: this.weeklyE[date] || 0,
         });
      //}
      }
      //this.series = values
      this.chartOptions.xaxis.categories = labels;
      //this.chartOptions = {xaxis: {type: "datetime", categories: labels, position: 'bottom'}}
    },
    
  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>
